import instance, { OFFERS_API_URL } from "../../api";

const offersApi = {
    // Get offers for a branch
    getOffersForBranch: (branchId) => {
        return instance(true, OFFERS_API_URL).get(`/admin/branches/${branchId}/offers`).then(res => res.data);
    },

    // Create offer for a branch
    createOffer: (branchId, data) => {
        return instance(true, OFFERS_API_URL).post(`/admin/branches/${branchId}/offers`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => res.data);
    },

    // Get all communities
    getCommunities: (params = {}) => {
        const queryParams = new URLSearchParams();
        if (params.limit) queryParams.append('limit', params.limit);
        if (params.offset) queryParams.append('offset', params.offset);
        const queryString = queryParams.toString();

        return instance(true, OFFERS_API_URL).get(`/v1/communities${queryString ? `?${queryString}` : ''}`).then(res => res.data);
    },

    // Update offer
    updateOffer: (branchId, offerId, data) => {
        return instance(true, OFFERS_API_URL).put(`/admin/branches/${branchId}/offers/${offerId}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => res.data);
    },

    // Delete offer
    deleteOffer: (branchId, offerId) => {
        return instance(true, OFFERS_API_URL).delete(`/admin/branches/${branchId}/offers/${offerId}`).then(res => res.data);
    },

    // Get single offer details
    getOfferDetails: (branchId, offerId) => {
        return instance(true, OFFERS_API_URL).get(`/admin/branches/${branchId}/offers/${offerId}`).then(res => res.data);
    },

    // Activate offer
    activateOffer: (branchId, offerId) => {
        return instance(true, OFFERS_API_URL).patch(`/admin/branches/${branchId}/offers/${offerId}/activate`).then(res => res.data);
    },

    // Suspend offer
    suspendOffer: (branchId, offerId) => {
        return instance(true, OFFERS_API_URL).patch(`/admin/branches/${branchId}/offers/${offerId}/suspend`).then(res => res.data);
    },
};

export default offersApi;
